import React, { useState } from "react";

const BlogStatusBox = ({ handleSubmit, editing }) => {
    const [status, setStatus] = useState(null); // ✅ start with no status
    const [isSaving, setIsSaving] = useState(false);
    const blogLink = "https://mysite.com/blog";

    const onAction = async (newStatus) => {
        setIsSaving(true);
        await handleSubmit(newStatus);
        setStatus(newStatus);
        setIsSaving(false);
    };

    const viewPost = () => {
        if (blogLink) window.open(blogLink, "_blank");
    };

    return (
        <>
            <h3 className="text-[16px] font-semibold text-black/80 mb-1">
                Blog Status
            </h3>

            {/* ✅ Show status ONLY if already set */}
            {status && (
                <p
                    className={`text-sm font-medium ${
                        status === "published" ? "text-green-600" : "text-yellow-600"
                    }`}
                >
                    {status === "published" ? "Live" : "In Draft"}
                </p>
            )}

            <div className="flex flex-col gap-2 mt-3 w-full">

                {/* ✅ Preview always visible */}
                <button
                    className="w-full p-2 text-sm font-semibold rounded-full bg-gray-700 text-white hover:bg-gray-800 transition"
                    onClick={viewPost}
                >
                    Preview
                </button>

                {/* ✅ Publish button if not live */}
                {status !== "published" && (
                    <button
                        onClick={() => onAction("published")}
                        className="w-full p-2 text-sm rounded-full text-white font-semibold bg-gradient-to-r from-blue-500 to-blue-800 hover:from-blue-600 hover:to-blue-900 transition-colors duration-300"
                    >
                        {isSaving ? "Publishing..." : editing ? "Update & Publish" : "Publish"}
                    </button>
                )}

                {/* ✅ Draft button when new OR switching back */}
                {(status === null || status === "published") && (
                    <button
                        onClick={() => onAction("draft")}
                        className="w-full p-2 text-sm rounded-full text-white font-semibold bg-gradient-to-r from-yellow-500 to-yellow-800 hover:from-yellow-600 hover:to-yellow-900 transition-colors duration-300"
                    >
                        {status === "published" ? "Move to Draft" : "Save as Draft"}
                    </button>
                )}

                {/* ✅ Show link only when published */}
                {status === "published" && (
                    <input
                        type="text"
                        value={blogLink}
                        readOnly
                        className="w-full border-b-2 border-gray-300 outline-none py-2 px-2 text-sm text-gray-700"
                    />
                )}
            </div>
        </>
    );
};

export default BlogStatusBox;
